import { useEffect, Component } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HostPage from "./pages/HostPage";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Spotlight } from "./components/Spotlight";
import { Events } from "./components/Events";
import { Hotels } from "./components/Hotel";
import { Livestream } from "./components/Livestream";
import { Rsvp } from "./components/Rsvp";
import { Footer } from "./components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-navy text-center">
          <div>
            <p className="font-script text-4xl text-gold-light">Something went astray</p>
            <p className="mt-3 text-sm text-mist">Please refresh the page to rejoin the celebration.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative bg-navy text-ivory">
      <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Spotlight />
          <Events />
          <Hotels />
          <Livestream />
          <Rsvp />
        </main>
        <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/host" element={<HostPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
